export const GET_EJARI = "GET_EJARI";
